// Import Redux actions for updating map view vehicles and unique vehicle data
import {setMapViewVehicle, setUniqueData} from '../MapDataSlice'
// Import the base API configuration
import AppApi from './API'
// Import configured axios instance for making HTTP requests
import axiosInstance from './AxiosInstance'

function normalizeMonitoringVehicle(vehicle: any) {
  const itemID = vehicle?.itemID ?? vehicle?.ItemID
  return {
    ...vehicle,
    itemID,
    registrationNo: vehicle?.registrationNo ?? vehicle?.RegistrationNo ?? '',
  }
}

function pruneMapViewVehicle(getState: () => any, uniqueData: {itemID: number}[], dispatch: any) {
  const prev: number[] = getState()?.MapData?.MapViewVehicle || []
  const idSet = new Set(uniqueData.map((v) => v.itemID))
  const next = prev.filter((id) => idSet.has(id))
  dispatch(setMapViewVehicle(next))
}

// Define and export RTK Query endpoints for vehicle monitoring functionality
export const MonitoringMapData = AppApi.injectEndpoints({
  endpoints: (builder) => ({
    // Query endpoint for fetching and processing vehicle monitoring data
    monitoringMap: builder.query({
      queryFn: async (
        {company, requestBody}: {company: number; requestBody: any},
        {dispatch, getState}: any
      ) => {
        try {
          // Make POST request to fetch vehicle monitoring data for the specified company
          const response = await axiosInstance.post(
            `/thiredparty/Vehicle-monitoring/${company}`,
            requestBody
          )
          const data = response.data
          const rawList = data?.data ?? []

          const uniqueData = Array.from(
            new Map(
              (Array.isArray(rawList) ? rawList : [])
                .map(normalizeMonitoringVehicle)
                .filter((vehicle: any) => vehicle.itemID)
                .map((vehicle: any) => [vehicle.itemID, vehicle])
            ).values()
          )

          // Always replace shared map list (including empty) so Available fleet rows cannot linger
          dispatch(setUniqueData(uniqueData))
          // Do not auto-select all — prune previous selection to ids still present
          pruneMapViewVehicle(getState, uniqueData, dispatch)

          return {data}
        } catch (error) {
          // Return error message if request fails
          return {error: (error as any).response?.data || 'Something went wrong'}
        }
      },
      // Tag for cache invalidation and updates
      providesTags: ['monitoringMap'],
    }),
  }),
})

// Export the generated RTK Query hook for component usage
export const {useMonitoringMapQuery} = MonitoringMapData
